import React, {useContext} from 'react'
import {Route, Switch, Redirect} from 'react-router-dom'
import {Query} from 'react-apollo'
import BarcodeErrorBoundary from './BarcodeErrorBoundary'
import {userQuery} from '../../graphql/barcode/queries/userSettingQuery'
import LoadingScreen from '../BarcodeLoadingScreen'
import BarcodePageNotFound from './BarcodePageNotFound'
import BarcodeMobileNotAvailable from './BarcodeMobileNotAvailable'
import BarcodeWizardPage from '../BarcodeWizardPage'
import BarcodeLibraryPage from '../BarcodeLibraryPage'
import BarcodeLibraryReprint from '../BarcodeLibraryTableActions/BarcodeLibraryReprint'
import BarcodeLibraryPreview from '../BarcodeLibraryTableActions/BarcodeLibraryPreview'
import BarcodeLibraryGenerateAuto from '../BarcodeLibraryTableActions/BarcodeLibraryGenerateAuto'
import BarcodeCreateLabel from '../BarcodeCreateLabel/BarcodeCreateLabel'
import BarcodeLanding from '../BarcodeLanding'
import BarcodeWizardGenerateSetting from '../BarcodeWizardGenerateSetting'
import BarcodeEditLabel from '../BarcodeEditLabel'
import BarcodeWizardAutoForm from '../BarcodeWizardAutoForm'
import BarcodeWizardFieldValueForm from '../BarcodeWizardFieldValueForm'
import BarcodeWizardGenerateFieldValue from '../BarcodeWizardGenerateFieldValue'
import BarcodeWizardGenerateAutomatic from '../BarcodeWizardGenerateAutomatic/BarcodeWizardGenerateAutomatic'
import {BarcodeUserSettingsContext} from '../../context/BarcodeUserSettings/BarcodeUserSettings'

export default function Routes(props) {
  const accountID = parseInt(window.localStorage.getItem('account_id'))
  const userId = parseInt(window.localStorage.getItem('user_id'))
  const accessToken = JSON.parse(window.localStorage.getItem('token'))

  const {setUserSettings} = useContext(BarcodeUserSettingsContext)

  function loadPage(setting) {
    if (window.localStorage.getItem('is_mobile') === 'true') {
      return '/not-available-mobile'
    }

    switch (setting) {
      case 'wizard':
        return '/barcode-wizard'
      case 'library':
        return '/barcode-library'
      case 'other':
        return '/barcode_generator'
      default:
        return 'PageNotFound'
    }
  }

  return (
    <BarcodeErrorBoundary>
      <Query
        query={userQuery}
        variables={{
          accountId: accountID,
          token: accessToken,
          userId: userId,
        }}
      >
        {({loading, error, data}) => {
          if (loading)
            return (
              <div>
                <LoadingScreen size={20} />
              </div>
            )
          if (error)
            return (
              <div>
                <Route component={BarcodePageNotFound} />
              </div>
            )
          setUserSettings(data.userSetting)

          return (
            <div>
              <Redirect to={loadPage(data.userSetting.setting)} />
              <Switch>
                <Route path="/barcode_generator" component={BarcodeLanding} />
                <Route path="/barcode-wizard" component={BarcodeWizardPage} />
                <Route path="/barcode-library" component={BarcodeLibraryPage} />
                <Route path="/new-label" component={BarcodeCreateLabel} />
                <Route path="/edit-label/:id" component={BarcodeEditLabel} />
                <Route
                  path="/barcode-wizard-generate-setting"
                  component={BarcodeWizardGenerateSetting}
                />
                <Route path="/barcode-wizard-auto-form" component={BarcodeWizardAutoForm} />
                <Route
                  path="/barcode-wizard-field-value-form"
                  component={BarcodeWizardFieldValueForm}
                />
                <Route path="/barcode-libray-reprint" component={BarcodeLibraryReprint} />
                <Route path="/barcode-library-preview" component={BarcodeLibraryPreview} />
                <Route
                  path="/barcode-libray-generate-automatic"
                  component={BarcodeLibraryGenerateAuto}
                />
                <Route
                  path="/barcode-wizard-generate-automatic"
                  component={BarcodeWizardGenerateAutomatic}
                />
                <Route
                  path="/barcode-wizard-generate-field-value"
                  component={BarcodeWizardGenerateFieldValue}
                />
                <Route path="/not-available-mobile" component={BarcodeMobileNotAvailable} />
                <Route component={BarcodePageNotFound} />
              </Switch>
            </div>
          )
        }}
      </Query>
    </BarcodeErrorBoundary>
  )
}
